import {
  INSTITUTE_LEGAL_STATUS_CHOICES,
  FUNDING_INSTRUMENT_CHOICES,
  IMPACT_METRIC_CHOICES,
  FUNDING_CURRENCY_CHOICES,
  FUNDED_INSTITUTION_CHOICES,
  PORTFOLIO_SIZE_CHOICES,
  SDGs,
  WORLD_REGION_CHOICES
} from "utils/choices.jsx";

const schema = {
  title: "",
  description: "",
  type: "object",
  properties: {
    legal_status: {
      type: "string",
      title: "Type",
      options: INSTITUTE_LEGAL_STATUS_CHOICES["Investor"]
    },
    working_regions: {
      type: "string",
      title: "Region of Intervention",
      options: WORLD_REGION_CHOICES
    },
    funding_offered: {
      type: "string",
      title: "Funding Instruments Offered",
      options: FUNDING_INSTRUMENT_CHOICES["Investor"]
    },
    funding_institution_type: {
      type: "string",
      title: "Type of Institution funded",
      options: FUNDED_INSTITUTION_CHOICES
    },
    funding_currency: {
      type: "string",
      title: "Funding Curerncy",
      options: FUNDING_CURRENCY_CHOICES
    },
    portfolio_size: {
      type: "string",
      title: "Portfolio Size",
      options: PORTFOLIO_SIZE_CHOICES
    },
    impact_metrics: {
      type: "string",
      title: "Relevant Impact Metrics & Tools",
      options: IMPACT_METRIC_CHOICES
    },
    funding_min: {
      type: "integer",
      title: "Minimum Amount of Funding (USD)"
    },
    funding_max: {
      type: "integer",
      title: "Maximum Amount of Funding (USD)"
    },
    term_min: {
      type: "integer",
      title: "Minimum Term (Months)"
    },
    term_max: {
      type: "integer",
      title: "Maximum Term (Months)"
    },
    sustainable_development_goals: {
      type: "string",
      title: "Sustainable Development Goals",
      options: SDGs
    },
    region: {
      type: "string",
      title: "Region",
      options: WORLD_REGION_CHOICES
    }
  }
};

const uiSchema = [
  {
    container: "griditem",
    items: {
      region: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      },
      sustainable_development_goals: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  },
  {
    container: "griditem",
    items: {
      legal_status: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      },
      working_regions: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  },
  {
    container: "griditem",
    items: {
      funding_institution_type: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      },
      funding_offered: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  },
  {
    container: "griditem",
    items: {
      portfolio_size: {
        "ui:widget": "select",
        "ui:emptyValue": ""
      },
      funding_currency: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  },
  {
    container: "griditem",
    items: {
      funding_min: {
        "ui:widget": "text",
        "ui:emptyValue": ""
      },
      funding_max: {
        "ui:widget": "text",
        "ui:emptyValue": ""
      }
    }
  },
  {
    container: "griditem",
    items: {
      term_min: {
        "ui:widget": "text",
        "ui:emptyValue": ""
      },
      term_max: {
        "ui:widget": "text",
        "ui:emptyValue": ""
      }
    }
  },
  {
    container: "griditem",
    items: {
      impact_metrics: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  }
];

export const InvestorFormSchema = {
  schema: schema,
  uiSchema: uiSchema
};
